import { userConstants } from "../../constants/ActionTypes";


const initialState = {
    full_name : "",
    // business_name : "",
    phone : "",
    email : "",
    password:"",
    email_otp:"",
    // otp:"",
    // emailOtp,
    // select:"",
    selectedState:"",
    // searchTerm : "",
    // search_type:"",
    terms_condition : false,
    signup_screen : true,
    login_phone : "",
    login_password : "",
    addBgClass:"signup_bg",
    trans_password:"",
    showPassword:false,
    showEmailPassword:false,
    login_screen:true,
    forgot_screen:"",
    newPassword_screen:"",
    businessName:"",
    emailVerified:false,
    forget_email:"",
    verify_email_otp:"",
    newPassword:"",
    confirmNewPAssword:"",
    otpToken:"",
    showcreatePassword:false,
    showConfirmcreatePassword:false,
    showEmailOtp:false

};

export function authentication(state = initialState, action) {
    switch (action.type) {
        case userConstants.REGISTER_REQUEST:
            return {
                ...state,
                ...action.payload
            };
        default:
            
            return state
    }
}